<template>
    <div>
        <div v-if="loading">
            <div id="app" class="loading-login">
                <div class="mpower-loading-logo-position">
                    <img :src="'images/mpower-new/login/logo-bg.png'" class="responsive-image mpower-img mx-auto" />

                    <!-- <div class="center-text own-title main-title margin-bottom-30">
                        GEN - GROW
                    </div> -->
                    <img :src="'images/mpower-new/login/loading.png'" class="responsive-image loading-img mx-auto" />
                </div>
                <div class="mpower-generali-position">
                    <img :src="'images/mpower-new/login/generali-bg.png'" class="responsive-image generali-img mx-auto" />
                </div>
            </div>
        </div>
         <div v-else-if="!loading">
            <div id="app" class="login">
                <div class="mpower-login-position">
                    <img :src="'images/mpower-new/login/logo-bg.png'" class="responsive-image mpower-img mx-auto" />
                </div>
                <div class="mpower-login-form-position">
                    <div class="welcome margin-bottom-10">
                        Welcome
                    </div>
                    <div class="margin-bottom-20">
                        <input class="login-input" type="text" name="password" v-model="password" placeholder="Passcode" />
                        <div v-if="error" class="danger margin-top-10 margin-bottom-20">{{msg}}</div>
                    </div>
                    <div class="margin-bottom-20">
                        <button @click="submit" class="generali-button">
                            Enter
                        </button>
                    </div>
                </div>

                <div class="mpower-generali-position">
                    <img :src="'images/mpower-new/login/generali-bg.png'" class="responsive-image generali-img mx-auto" />
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.mpower-loading-logo-position {
    position: absolute;
    top: 35vh;
    left: 0;
    right: 0;
}

.mpower-loading-spinner-position{
    position: absolute;
    top: 60vh;
    left: 0;
    right: 0;
}

.mpower-generali-position {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
}

.mpower-login-position {
    position: absolute;
    top: 25vh;
    left: 0;
    right: 0;
}

.mpower-login-form-position {
    position: absolute;
    top: 45vh;
    left: 0;
    right: 0;
}

.generali-img {
    width: 350px;
}

.welcome {
    font-family: "HelveticaNeueLTStd-Bd";
    font-size: 14px;
    color: #fff;
}

.login-input {
    width: 270px;
    height: 40px;
    text-align: center;
    font-size: 14px;
    -webkit-border-radius: 5px!important;
}

.generali-button{
    padding: 10px 10px;
}

::placeholder{
    color: #A6A5A4;
}

.danger {
    color: red;
    font-size: 14px;
}

.mx-auto {
    margin: 0 auto;
}
.mpower-img {
    width: 450px;
}
.loading-img {
    width: 30px;
}

@media(max-width: 765px){

    /* .mpower-img {
    width: 40px;
} */
    .generali-img {
        width: 330px;
    }
}
</style>
<script>
export default {
    name: 'Login',
    data() {
        return {
            default: 'gengrow',
            loading: true,
            password: '',
            error: false,
            msg: '',
            height:screen.height+"px"
        }
    },
    computed: {
    },
    beforeMount(){
        try{
            var check = localStorage.getItem('isAuth')
            if(check==='1'){
                this.loading=false
                this.$router.push({path:'home'})
            }
            else{
                setInterval(()=>{this.loading=false},1500)
            }
        }
        catch(e){
            setInterval(()=>{this.loading=false},1500)
        }
    },
    methods: {
        submit() {
            if(this.password==''){
                this.error = true
                this.msg = 'Passcode required'
                return 
            }

            if(this.password.toLowerCase()!==this.default){
                this.error = true
                this.msg = 'Incorrect Passcode'
                return 
            }
            localStorage.setItem('isAuth',1)
            this.$router.push({
                path: 'home'
            })
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        }
    },
}
</script>